<template>
  <div class="order-detail">
    <div class="content-crumbs">
      <el-button
        size="mini"
        type="primary"
        icon="icon-ccui-return"
        class="crumbs-back"
        @click="crumbsBack"
        >返回</el-button
      >
      <div class="line" />
      <!-- 面包屑 -->
      <el-breadcrumb separator-class="el-icon-arrow-right" class="crumbs">
        <el-breadcrumb-item :to="{ path: '/#/zh-CN/component/breadcrumb' }"
          >审批</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/#/zh-CN/component/breadcrumb' }"
          >合同</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/#/zh-CN/component/breadcrumb' }"
          >已办</el-breadcrumb-item
        >
        <el-breadcrumb-item>采购订单demo</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 数据总览卡 -->
    <div class="content-card">
      <el-data-card
        :card-type="cardType"
        :order-num="orderNum"
        :money-data="moneyData"
      />
      <el-data-card
        :card-type="cardType"
        :order-num="orderNum"
        :money-data="moneyData"
      />
      <el-data-card
        :card-type="cardType"
        :order-num="orderNum"
        :money-data="moneyData"
      />
    </div>
    <!-- 表格 -->
    <div id="print-box" class="content-table-box">
      <div class="content-table">
        <el-card-title
          :title="title"
          :content-text="content"
          class="details-header"
        />
        <el-table
          :row-class-name="structure"
          :header-cell-style="{ background: '#ffffff', color: '#4A4A4A' }"
          :data="tableData"
          style="width: 100%"
          row-key="id"
          border
          class="table-content"
        >
          <el-table-column
            :index="indexMethod"
            type="index"
            label="序号"
            width="43"
            height="90px"
          />
          <el-table-column
            prop="name"
            label="采购单位/经办部门"
            min-width="244"
          />
          <el-table-column prop="type" label="类型" width="130" />
          <el-table-column prop="number" label="电子超市/工程专区" width="660">
            <el-table-column prop="number" label="本周">
              <el-table-column prop="weekCount" label="订单数(个)" />
              <el-table-column
                cell-style="text-align:right;"
                prop="weekAmount"
                label="订单金额(元)"
              />
            </el-table-column>
            <el-table-column prop="number" label="本月">
              <el-table-column prop="monthCount" label="订单数(个)" />
              <el-table-column prop="monthAmount" label="订单金额(元)" />
            </el-table-column>
            <el-table-column prop="number" label="本年">
              <el-table-column prop="yearCount" label="订单数(个)" />
              <el-table-column prop="yearAmount" label="订单金额(元)" />
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-bottom-print-export @export-click="exportClick" />
  </div>
</template>

<script>
// import { getList } from "@/api/order-detail";
import ExcelJS from "exceljs/dist/es5/exceljs.browser.js";
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      pageNo: 4,
      pageSize: 10,
      printWidth: "",
      downloadLoading: false,
      title: "采购单位订单采购统计表",
      content: "制表单位/人: 中交信科/游欢欢 2019.04.01",
      // company: '中交信科',
      // people: '游欢欢',
      // time: '2019.04.02',
      cardType: "本周",
      orderNum: 1234,
      moneyData: 12345.123,
      aaaData: [],
      tableData: [],
    };
  },
  mounted() {},
  created() {
    this.getList();
  },
  methods: {
    crumbsBack() {
      this.$router.push({ path: "/statistic/order/purchaser/order-statistic" });
      console.log(1111);
    },
    expandData(arr) {
      return Array.isArray(arr)
        ? arr.reduce((prev, cur) => {
            const curObj = { ...cur };
            delete curObj.children;
            return cur.children
              ? prev.concat([curObj]).concat(this.expandData(cur.children))
              : prev.concat([curObj]);
          }, [])
        : arr;
    },
    exportClick() {
      // console.log('导出调用')
      saveAsExcel.call(this);

      async function saveAsExcel() {
        const wb = new ExcelJS.Workbook();
        const ws1 = wb.addWorksheet("交建第一页");
        // 添加表头
        ws1.addRow([
          "序号",
          "采购单位/经办部门",
          "类型",
          "电子超市/工程专区",
          "",
          "",
          "",
          "",
          "",
        ]);
        ws1.addRow(["", "", "", "本周", "", "本月", "", "本年", ""]);
        ws1.addRow([
          "",
          "",
          "",
          "订单数(个)",
          "订单金额(元)",
          "订单数(个)",
          "订单金额(元)",
          "订单数(个)",
          "订单金额(元)",
        ]);
        // 合并表头
        ws1.mergeCells("A1:A3");
        ws1.mergeCells("B1:B3");
        ws1.mergeCells("C1:C3");
        ws1.mergeCells("D1:I1");
        ws1.mergeCells("D2:E2");
        ws1.mergeCells("F2:G2");
        ws1.mergeCells("H2:I2");
        // 注入表格数据
        ws1.columns = [
          { header: "序号", key: "id", width: 32 },
          { header: "采购单位/经办部门", key: "name", width: 32 },
          { header: "类型", key: "type", width: 32 },
          { header: "订单数(个)", key: "number", width: 32 },
        ];
        const arr = this.expandData(this.tableData);
        // console.log('ttttttt', arr)
        const obj = [];
        const colorArr = [
          "003333",
          "103930",
          "20402D",
          "304629",
          "404D26",
          "505323",
          "605920",
          "70601D",
          "80661A",
          "8F6C16",
          "9F7313",
          "AF7910",
          "BF800D",
          "CF860A",
          "DF8C06",
          "EF9303",
          "FF9900",
        ];
        arr.forEach((item, index) => {
          obj[index] = ws1.addRow(item);
          const colorId = item.id.split("-").length - 1;
          obj[index].fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: colorArr[colorId] },
          };
          obj[index].font = { bold: true, color: { argb: "ffffff" } };
        });
        const buf = await wb.xlsx.writeBuffer();
        saveAs(new Blob([buf]), "abc.xlsx");
      }
    },
    indexMethod(index) {
      return index + 1;
    },
    structure(evt) {
      // console.log('xxxx', evt)
      const { row } = evt;
      if (row.children) {
        // 树状结构运算
        // console.log(222222)
      }
      return !row.children ? "" : "endLevel";
    },
    getList() {
      this.aaaData = [];
      const obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowLoading: true,
        data: { ...this.formLabelAlign },
      };
      getList(obj).then((res) => {
        console.log("jjjjjjjj", res.data.data); // 拿到请求数据
        const cardArr = res.data.data;
        this.tableData = cardArr;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-detail {
  min-height: 800px;
}
.content-crumbs {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.line {
  width: 1px;
  height: 21px;
  background: rgba(216, 216, 216, 1);
  margin: 0 20px;
}

.content-card {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}

.content-table-box {
  background: #fff;
  padding: 0 20px 20px;
  margin-bottom: 80px;
  .content-table {
    margin: 0 auto;
    background: #fff;
    .details-header {
      margin: 0 0 20px 0;
      height: 36px;
    }
    /deep/ .el-table {
      font-size: 13px;
      color: #4a4a4a;
      td {
        /*padding: 6px 0;*/
        height: 36px;
      }
      th {
        padding: 3px 0;
      }
      .el-table_1_column_4_column_5_column_7 {
        text-align: right;
      }
      .el-table_1_column_4_column_8_column_10 {
        text-align: right;
      }
      .el-table_1_column_4_column_11_column_13 {
        text-align: right;
        border-right: #fff;
      }
      .el-table_1_column_4 {
        border-right: #fff;
      }
      .el-table_1_column_4_column_11 {
        border-right: #fff;
      }
      /deep/ .endLevel {
        .el-table_1_column_4_column_5_column_6 {
          width: 94px;
          height: 18px;
          font-size: 13px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #0089ef;
          line-height: 18px;
        }
        .el-table_1_column_4_column_5_column_7 {
          width: 94px;
          height: 18px;
          font-size: 13px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #0089ef;
          line-height: 18px;
        }
        .el-table_1_column_4_column_8_column_9 {
          width: 94px;
          height: 18px;
          font-size: 13px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #0089ef;
          line-height: 18px;
        }
        .el-table_1_column_4_column_8_column_10 {
          width: 94px;
          height: 18px;
          font-size: 13px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #0089ef;
          line-height: 18px;
        }
        .el-table_1_column_4_column_11_column_12 {
          width: 94px;
          height: 18px;
          font-size: 13px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #0089ef;
          line-height: 18px;
        }
        .el-table_1_column_4_column_11_column_13 {
          width: 94px;
          height: 18px;
          font-size: 13px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #0089ef;
          line-height: 18px;
        }
      }
    }
  }
}

.content-print {
  z-index: 5;
  position: fixed;
  bottom: 0;
  height: 80px;
  padding: 20px 0;
  background: rgba(241, 241, 241, 1);
  width: 100%;
}

.content-print-box {
  position: absolute;
}

.el-bottom-print-export {
  width: 100%;
  padding: 0;
  margin: 0;
}

.el-bottom-print-export > .bottom-box {
  width: 100%;
  height: 40px;
  background: rgba(76, 76, 76, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  color: #ffffff;
}

.el-bottom-print-export > .bottom-box > i {
  margin-right: 10px;
}

.el-bottom-print-export > .bottom-box > .export {
  margin-left: 25px;
}

.el-table--border {
  border: none;
}
.el-table--border::after {
  background: #fff;
}
.el-table--group {
  border-top: 1px solid rgba(241, 241, 241, 1);
}
.el-table_1_column_1 {
  height: 36px;
  padding: 0;
}

.el-table_1_column_1 > .cell {
  padding: 0;
  display: flex;
  justify-content: center;
}
//树状表格颜色区分

@media print {
  @page {
    size: A4 landscape;
    /*size: 195mm 275mm;*/
  }
  body,
  article {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .content-table {
    table {
      width: 270mm !important;
    }
    .el-table--border {
      width: 100%;
      border-bottom: 1px solid #ebeef5;
      ::after {
        background: #fff;
      }
    }
  }
}
</style>
